class Top {
    constructor(el, opt) {
      this.el = el;
      if($(this.el).length){
        this.event();
      }
    }
    event(){
      var swiper = new Swiper(".mySwiper", {
        autoplay: {
          delay: 4000,
        },
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
				pagination: {
          el: '.swiper-pagination',  //ページネーションの要素のセレクタ
					type: 'bullets',  //ページネーションのタイプ
				},
        breakpoints: {
          960: {
            slidesPerView: 1.3,
            spaceBetween: 50,
          }
        }
      });

      if (window.matchMedia('(max-width: 979px)').matches) {
        var swiper = new Swiper(".works-achieve-swiper", {
          autoplay: {
            delay: 2000,
          },
          speed: 1500,
          slidesPerView: 1.1,
          spaceBetween: 20,
          loop: true,
          centeredSlides: true,
        });
      }

      $('.js-drawer').on({
        click: function() {
          $('.js-header').toggleClass('is-acitve');
          $('html').toggleClass('no-scroll');
        }
      })


      function topNews () {
        const newsList = document.querySelectorAll(".news-content > a")
        console.log(newsList);
        const arrowTop =  document.querySelector(".arrow-top")
        const arrowBottom =  document.querySelector(".arrow-bottom")
        let newsNum = 0;


        if(newsList.length !== 0 ){
          newsList[newsNum].classList.add("is-active");
          arrowTop.addEventListener("click", function() {
            if(newsList[0].classList.contains("is-active")){
              arrowTop.style.pointerEvents = "";
              return;
            }

            if(newsNum < newsList.length){
              newsList[newsNum].classList.remove("is-active");
              newsNum --;
              newsList[newsNum].classList.add("is-active");
            }

          })

          arrowBottom.addEventListener("click", function() {
            if(newsList[newsList.length - 1].classList.contains("is-active")){
              arrowBottom.style.pointerEvents = "";
              return;
            }

            if(newsNum < newsList.length){
              newsList[newsNum].classList.remove("is-active");
              newsNum ++;
              newsList[newsNum].classList.add("is-active");
            }
          })
        }

      }

      topNews();

      if( window.matchMedia("screen and (max-width:960px)").matches ) {
        var swiper = new Swiper(".rankingSwiper", {
          // autoplay: {
          //   disableOnInteraction: false,
          //   delay: 4000,
          //   },
          slidesPerView: 2,
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            // スライドの表示枚数：500px以上の場合
            960: {
              slidesPerView: 4,
            }
          }
        });

        var swiper = new Swiper(".campaignSwiper", {
          // autoplay: {
          //   disableOnInteraction: false,
          //   delay: 4000,
          //   },
          slidesPerView: 1.1,
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            // スライドの表示枚数：500px以上の場合
            960: {
              slidesPerView: 4,
            }
          }
        });
      }
    }
  }
